import { UseQueryOptions } from '@tanstack/react-query';

import { useAPI } from 'hooks/api/useAPI';

import APIError from 'types/api_error';
import { Stream } from 'types/stream';

import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

export function useStream(
  streamId: string | null | undefined,
  { enabled, ...options }: UseQueryOptions<Stream, APIError> = {}
) {
  const { applicationID, client } = useAPI();

  return useAuthenticatedQuery(
    ['stream', streamId, applicationID],
    async () => {
      if (!streamId) {
        return Promise.reject('No stream id provided.');
      }

      const { data } = await client.get(
        `/apps/${applicationID}/streams/${streamId}`
      );

      return data;
    },
    {
      enabled:
        enabled !== undefined
          ? Boolean(streamId) && enabled
          : Boolean(streamId),
      ...options,
    }
  );
}
